import InquiryForm from '../components/InquiryForm';

export default function AddInquiryForm() {
  return (
    <InquiryForm />
  );
}
